import { differenceInYears } from 'date-fns';
import * as yup from 'yup';

yup.addMethod(yup.string, 'checkPhoneNumber', function (message) {
  return this.test('checkPhoneNumber', message, function (value) {
    if (!value) return true;

    if (!/^(08)/.test(value))
      return this.createError({
        path: this.path,
        message: 'Nomor telepon harus dimulai dari 08xxxxxxxx',
      });

    if (value.length > 13 || value.length < 10)
      return this.createError({
        path: this.path,
        message: 'Harap isi dengan angka 10-13 karakter',
      });

    return (
      /^(62|0)8[1-9][0-9]{6,11}$/.test(value) ||
      this.createError({ path: this.path, message })
    );
  });
});

yup.addMethod(
  yup.string,
  'checkMinimumDob',
  function (message, minimumAge = 21) {
    return this.test('checkMinimumDob', message, function (value) {
      if (!value) return true;
      const differenceYear = differenceInYears(new Date(), new Date(value));

      return (
        differenceYear >= minimumAge ||
        this.createError({ path: this.path, message })
      );
    });
  },
);
